import { useState } from "react";
import type { AnimeEpisode } from "@/types";

interface EpisodeListProps {
  episodes: AnimeEpisode[];
  animeTitle: string;
}

export default function EpisodeList({ episodes, animeTitle }: EpisodeListProps) {
  const [selected, setSelected] = useState(episodes[0]?.no ?? 1);
  const current = episodes.find((e) => e.no === selected) ?? episodes[0];

  if (!episodes || episodes.length === 0) {
    return (
      <div className="rounded-lg bg-background-100 border border-background-200 p-6 text-sm text-foreground-500">
        暂无章节信息。
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-background-200 overflow-hidden">
      {/* Chapter viewer */}
      <div className="relative bg-foreground-950 p-6 md:p-8">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-2 text-background-50">
            <span className="px-2.5 py-1 rounded bg-primary-500 text-background-50 text-xs font-semibold">
              第 {current.no} 集
            </span>
            <h3 className="font-heading font-bold text-lg">{current.title}</h3>
          </div>
          <span className="text-xs text-background-100/70">{current.duration}</span>
        </div>
        <p className="mt-4 text-sm leading-relaxed text-background-100/80 max-w-2xl">
          《{animeTitle}》第 {current.no} 集「{current.title}」。本站为动漫资讯展示平台，目前暂不提供在线播放功能，本章节内容以文字简介形式呈现，播放与观看功能将在后续版本中开发，敬请期待。
        </p>
      </div>

      {/* Episode grid */}
      <div className="p-4 md:p-5 bg-background-50">
        <div className="flex items-center justify-between mb-3">
          <h4 className="font-heading font-semibold text-sm text-foreground-950">
            章节列表（共 {episodes.length} 集）
          </h4>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
          {episodes.map((ep) => (
            <button
              key={ep.no}
              type="button"
              onClick={() => setSelected(ep.no)}
              title={ep.title}
              className={`h-10 rounded-md text-sm font-medium transition-colors cursor-pointer truncate px-2 ${
                ep.no === selected
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {ep.no}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}